import React, { useEffect } from 'react';
import type { WorkspaceRuntimeMode } from './runtime.js';

export function WorkspaceRuntimeBoundary({
  runtime,
  children,
  standalone,
  disabledTitle = 'Standalone Access Disabled',
  disabledMessage = 'This workspace is embedded through the OSS shell outside localhost development.',
}: {
  readonly runtime: WorkspaceRuntimeMode;
  readonly children: React.ReactNode;
  readonly standalone: React.ReactNode;
  readonly disabledTitle?: string;
  readonly disabledMessage?: string;
}) {
  useEffect(() => {
    document.body.dataset.embedded = runtime === 'embedded' ? 'true' : 'false';

    return () => {
      delete document.body.dataset.embedded;
    };
  }, [runtime]);

  if (runtime === 'embedded') {
    return <main className="content content-embedded">{children}</main>;
  }

  if (runtime === 'standalone-disabled') {
    return (
      <main className="content">
        <section className="panel">
          <h1>{disabledTitle}</h1>
          <p>{disabledMessage}</p>
        </section>
      </main>
    );
  }

  return <>{standalone}</>;
}
